import React, { Component } from 'react';

class DeleteModal extends Component {
    render() {
        const { show, currentItem, loading, onClose, onDelete } = this.props;

        if (!show || !currentItem) return null;

        return (
            <>
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Xác nhận xóa</h5>
                                <button 
                                    type="button" 
                                    className="btn-close" 
                                    onClick={onClose}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>Bạn có chắc chắn muốn xóa nền phòng <strong>"{currentItem.name}"</strong>?</p>
                                <p className="text-muted">Hành động này không thể hoàn tác.</p>
                            </div>
                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                >
                                    Hủy
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-danger"
                                    onClick={onDelete}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <>
                                            <span className="loading-spinner"></span>
                                            Đang xóa...
                                        </>
                                    ) : (
                                        'Xóa'
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div 
                    className="modal-backdrop fade show"
                    onClick={onClose}
                ></div>
            </>
        );
    }
}

export default DeleteModal;
